var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"infoLabel_main"}},[_c('div',{attrs:{"id":"infoLabel_head"}},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('div',{attrs:{"id":"infoLabel_body"}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }